// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__3AIxt","path":"style_path__3SGp9","arrow":"style_arrow__2sgjT"};